import { useCallback } from "react";

import * as Sentry from "@sentry/browser";
import { useMutation } from "react-relay";

import { AddBindingMutation } from "app/mutations";

import type {
  AddBindingInput,
  AddBindingMutation as AddBindingMutationType,
  AddBindingMutation$data,
} from "app/mutations/__generated__/AddBindingMutation.graphql";
import type { Disposable } from "react-relay";
import type { PayloadError } from "relay-runtime";

interface Params {
  input: AddBindingInput;
  connections: string[];
  onCompleted?: (
    response: AddBindingMutation$data,
    errors: PayloadError[],
  ) => void;
  onErrors?: (errors: string[]) => void;
}

export function useAddBinding(): [
  (
    params: Params,
    onCompleted: (
      response: AddBindingMutation$data,
      errors: PayloadError[] | null,
    ) => void,
  ) => Disposable,
  boolean,
] {
  const [commit, isInFlight] =
    useMutation<AddBindingMutationType>(AddBindingMutation);

  return [
    useCallback(
      (
        params: Params,
        onCompleted: (
          response: AddBindingMutation$data,
          errors: PayloadError[] | null,
        ) => void,
      ) => {
        return commit({
          variables: {
            input: params.input,
            connections: params.connections,
          },
          onCompleted: (response, errors) => onCompleted(response, errors),
          onError: (err) => {
            Sentry.captureException(err);
          },
        });
      },
      [commit],
    ),
    isInFlight,
  ];
}
